import { localeSchema, type Locale } from '@xfile/shared';

/** Clé de persistance de la langue choisie. */
export const LOCALE_STORAGE_KEY = 'xfile.locale';

/** Langue de repli si aucune préférence ni langue système exploitable : ANGLAIS. */
export const DEFAULT_LOCALE: Locale = 'en';

/**
 * Ordre de résolution : `localStorage` → langue(s) du SYSTÈME (navigateur) →
 * repli `en`. Le défaut est donc la langue du système, avec l'anglais en dernier
 * recours. Tolérant à un `localStorage` indisponible (mode privé, SSR/test).
 */
export function detectInitialLocale(): Locale {
  const stored = readStoredLocale();
  if (stored) return stored;

  const candidates =
    typeof navigator !== 'undefined'
      ? [...(navigator.languages ?? []), navigator.language].filter(Boolean)
      : [];
  for (const raw of candidates) {
    const parsed = localeSchema.safeParse(raw.slice(0, 2).toLowerCase());
    if (parsed.success) return parsed.data;
  }
  return DEFAULT_LOCALE;
}

/** Lit la langue persistée, ou `null` si absente/invalide/indisponible. */
export function readStoredLocale(): Locale | null {
  try {
    const raw = localStorage.getItem(LOCALE_STORAGE_KEY);
    if (!raw) return null;
    const parsed = localeSchema.safeParse(raw);
    return parsed.success ? parsed.data : null;
  } catch {
    return null;
  }
}

/** Persiste la langue choisie (silencieux si `localStorage` indisponible). */
export function storeLocale(locale: Locale): void {
  try {
    localStorage.setItem(LOCALE_STORAGE_KEY, locale);
  } catch {
    /* stockage indisponible : on continue sans persistance */
  }
}
